<template>
  <div class="main">
    <nav class="header">
      <div class="wrap-header">
        <router-link to="/">
          <img src="../assets/abi-vertical.png" alt="" class="img-logo" />
        </router-link>
        <ul class="links">
          <div v-if="!isLogin" class="sub-nav"></div>
          <div v-if="isLogin" class="sub-nav-login">
            <span>{{ username }}</span>
            <b-button variant="outline-info" class="mb-2" @click="logout"> <b-icon icon="power" aria-hidden="true"></b-icon> Logout </b-button>
            <!-- <li class="nav-link">
              {{ userProfil }}
              <ul class="dropdown-link">
                <router-link to="/profil" v-show="role == 2"><li>Profil</li></router-link>
                <li @click="logout">Logout</li>
              </ul>
            </li> -->
          </div>
        </ul>
      </div>
    </nav>
    <div class="main-content">
      <router-view></router-view>
    </div>
    <div class="footer">
      <span>ABI Commodity Future</span>
      <div class="contact">
        <div>
          <img src="../assets/call-answer.png" alt="telepone" />
          <span>+6221 5761461</span>
        </div>
        <div>
          <img src="../assets/message-closed-envelope.png" alt="email" />
          <span>info@abicommodity.co.id</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from "axios";
export default {
  data() {
    return {
      username: "",
      photo: "",
    };
  },
  mounted() {
    Axios.get("/v2/user/profile").then((res) => {
      this.username = res.data.data.user.account_code;
    });
  },
  computed: {
    isLogin() {
      return this.$store.getters.isAuthenticated;
    },
    userProfil() {
      let user = localStorage.getItem("username");
      return user;
    },
    role() {
      let role = localStorage.getItem("role");
      // console.log(role)
      return role;
    },
  },

  methods: {
    logout() {
      this.$store.dispatch("logout").then(() => {
        let role = localStorage.getItem("role");
        if (role == 5) {
          this.$router.go("/login-admin");
        } else {
          this.$router.go("/home");
        }
      });
    },
  },
};
</script>

<style scoped>
.header {
  min-height: 62px;
}

.wrap-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 93%;
  margin: 0 auto;
}

.img-logo {
  width: 82px;
}

.main {
  min-height: 100vh;
  margin: 0;
  display: grid;
  grid-template-rows: auto 1fr auto;
}
.footer {
  background: #1e354a;
  color: white;
  padding: 20px 47px;
  display: flex;
  justify-content: space-between;
  margin-top: auto;
  height: 62px;
}

.footer span {
  font-size: 14px;
  flex: 2;
}

.footer .contact {
  display: flex;
  /* width: 30%; */
  justify-content: space-between;
}

.footer .contact div:first-child {
  margin-right: 51px;
}

.footer .contact img {
  width: 20px;
  margin-right: 11px;
}

.footer .contact span {
  font-size: 12px;
}
</style>
